import { ModelDataType } from 'src/app/interfaces/model-data-type';

import { MailingAddress, StreetAddress } from '.';
import { Address } from './address';
import { BaseModel } from './base-model';
import { Company } from './company';

export class CompanyOffice extends BaseModel {
  static override columnMap = new Map<
    string,
    { property: string; type: 'column'; dataType: ModelDataType }
  >();
  static override associationMap = new Map<
    string,
    { property: string; type: 'association'; model: string }
  >();
  static override aliasedColumnMap = new Map<
    string,
    { property: string; type: 'alias' }
  >();

  static CompanyOfficeProperties: (
    | {
        property: keyof CompanyOffice;
        type: 'column';
        dataType: ModelDataType;
      }
    | {
        property: keyof CompanyOffice;
        type: 'alias';
      }
    | {
        property: keyof CompanyOffice;
        type: 'association';
        model: string;
      }
  )[] = [
    { property: 'id', type: 'column', dataType: 'number' },
    { property: 'CompanyId', type: 'column', dataType: 'number' },
    { property: 'officeName', type: 'column', dataType: 'string' },
    { property: 'createdAt', type: 'column', dataType: 'date' },
    { property: 'updatedAt', type: 'column', dataType: 'date' },

    { property: 'Address', model: 'Address', type: 'association' },
    { property: 'StreetAddress', model: 'StreetAddress', type: 'association' },
    {
      property: 'MailingAddress',
      model: 'MailingAddress',
      type: 'association'
    },
    { property: 'Company', model: 'Company', type: 'association' }
  ];

  static {
    CompanyOffice.CompanyOfficeProperties.forEach((propertyObject) => {
      const { property, type } = propertyObject;
      if (type === 'column') {
        CompanyOffice.columnMap.set(property, propertyObject);
      }
      if (type === 'alias') {
        CompanyOffice.aliasedColumnMap.set(
          property,
          propertyObject as { property: string; type: 'alias' }
        );
      }
      if (type === 'association') {
        CompanyOffice.associationMap.set(
          property,
          propertyObject as {
            property: string;
            type: 'association';
            model: string;
          }
        );
      }
    });
  }

  constructor(CompanyOfficeObject: Partial<CompanyOffice>) {
    super();

    CompanyOffice.CompanyOfficeProperties.forEach((propertyObject) => {
      const { property } = propertyObject;
      const value = CompanyOfficeObject[property];
      if (value !== undefined) {
        Object.assign(this, { [property]: value });
      }
    });
  }

  id?: number;
  CompanyId?: number;
  officeName?: string;
  createdAt?: Date;
  updatedAt?: Date;

  Address?: Address;
  StreetAddress?: StreetAddress;
  MailingAddress?: MailingAddress;
  Company?: Company;
}
